import { WorkoutSettings } from 'fitbeat.gym-core';
import { Gender, Gym, ProgramType } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { default as BodyGroupWorkoutSettings } from './BodyGroupWorkoutSettings';

interface IProps {
  gender: Gender;
  gym: Gym;
  showGymEquipment: boolean;
  longTermGoal?: ProgramType;
  workoutSettings: WorkoutSettings;
  showCusomiseWorkoutSettings: boolean;
  t(key: string): string;
  personaliseWorkout(): void;
}

export function WorkoutSettingsSummary({
  t,
  gender,
  gym,
  workoutSettings,
  showGymEquipment,
  personaliseWorkout,
  showCusomiseWorkoutSettings,
}: IProps) {
  return (
    <View>
      <BodyGroupWorkoutSettings
        gender={gender}
        workoutSettings={workoutSettings}
        showGymEquipment={showGymEquipment}
        gym={gym}
      />
      { showCusomiseWorkoutSettings && (
      <Button
        title={t('customise')}
        onPress={personaliseWorkout}
        buttonType={ButtonTypes.TRANSPARENT}
        containerStyle={styles.buttonContainer}
      />
      ) }
    </View>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    height: defaultScale(22),
  },
});
